import api from '@/api/deliveryCities';

const state = {
  all: [],
};

const getters = {
  cities: (state) => state.all,
};

const actions = {
  async getCities({ commit }) {
    const result = await api.getAll();
    commit('setCities', result.data);
    return result.data;
  },
  async createCity({ commit }, city) {
    const result = await api.post(city);
    commit('addCity', result.data);
    return result.data;
  },
  async updateCity({ commit }, city) {
    const result = await api.put(city);
    commit('updateCity', result.data);
    return result.data;
  },
  async deleteCity({ commit }, id) {
    await api.delete(id);
    commit('removeCity', id);
  },
};

const mutations = {
  setCities(state, cities) {
    state.all = cities;
  },
  addCity(state, city) {
    state.all.push(city);
  },
  updateCity(state, city) {
    const index = state.all.findIndex((c) => c.id === city.id);
    if (index !== -1) state.all.splice(index, 1, city);
  },
  removeCity(state, id) {
    const index = state.all.findIndex((c) => c.id === id);
    if (index !== -1) state.all.splice(index, 1);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
